import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

type UseTooltipParams = Readonly<{
  isDisabled: boolean;
  title: ReactNode;
}>;

function useTooltip({ isDisabled, title }: UseTooltipParams) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isDisabled) setIsOpen(false);
  }, [isDisabled]);

  useEffect(() => {
    if (!isOpen) return;
    // En fase de captura y frenando la propagación: con el tooltip abierto, Escape debe
    // descartarlo a él y a nada más (WCAG 1.4.13). Sin esto, dentro de un Dialog el Modal
    // de MUI se traga la tecla antes de que llegue aquí y cierra el diálogo entero.
    function handleEscape(e: KeyboardEvent) {
      if (e.key !== 'Escape') return;
      e.stopPropagation();
      setIsOpen(false);
    }
    document.addEventListener('keydown', handleEscape, true);
    return () => document.removeEventListener('keydown', handleEscape, true);
  }, [isOpen]);

  function handleOpen() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  const hasContent = !isDisabled && Boolean(title);

  return { handleClose, handleOpen, hasContent, isOpen };
}

export default useTooltip;
